import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface IUpdateBillingSlice {
  isUpdateBillingLoading: boolean;
  isUpdateBillingSuccess: boolean;
  updateBillingError: Error | null;
  updateBillingIsFormChanged: boolean;
  updateBillingPaymentCanBeUpdated: boolean;
}

export const createUpdateBillingSliceDefaultValues = (): IUpdateBillingSlice => ({
  isUpdateBillingSuccess: false,
  isUpdateBillingLoading: false,
  updateBillingError: null,
  updateBillingIsFormChanged: false,
  updateBillingPaymentCanBeUpdated: false,
});

export const createUpdateBillingSlice: StateCreator<IUpdateBillingSlice> = () =>
  createUpdateBillingSliceDefaultValues();

export type UpdateBillingPageStore = UseBoundStore<StoreApi<IUpdateBillingSlice>>;

export const createUpdateBillingHooks = (pageStore: UpdateBillingPageStore) => {
  return {
    useIsLoading: () => pageStore((state) => state.isUpdateBillingLoading),
    useFormIsDirty: () => pageStore((state) => state.updateBillingIsFormChanged),
    usePaymentCanChange: () => pageStore((state) => state.updateBillingPaymentCanBeUpdated),
  };
};

export type UpdateBillingHooks = ReturnType<typeof createUpdateBillingHooks>;
